import { OnInit } from '@angular/core';
import { DacConfig } from 'app/shared/services/dac-config.service';
var HomeComponent = /** @class */ (function () {
    function HomeComponent(dacConfig) {
        this.dacConfig = dacConfig;
        this.title = dacConfig.applicationTitle;
    }
    HomeComponent.prototype.ngOnInit = function () {
    };
    HomeComponent.prototype.ngAfterViewInit = function () {
    };
    HomeComponent.prototype.ngOnDestroy = function () {
    };
    Object.defineProperty(HomeComponent.prototype, "supportPhone", {
        get: function () {
            return this.dacConfig.supportPhone;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HomeComponent.prototype, "supportEmail", {
        get: function () {
            return this.dacConfig.supportEmail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HomeComponent.prototype, "mailLink", {
        get: function () {
            return "mailto:" + this.supportEmail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HomeComponent.prototype, "phoneLink", {
        get: function () {
            return "tel:" + this.supportPhone;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HomeComponent.prototype, "copyrightTitle", {
        get: function () {
            return this.dacConfig.copyrightTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HomeComponent.prototype, "copyrightURL", {
        get: function () {
            return this.dacConfig.copyrightURL;
        },
        enumerable: true,
        configurable: true
    });
    return HomeComponent;
}());
export { HomeComponent };



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts.pre-build-optimizer.js